<template>
  <div class="bg-gray-900 py-8 lg:py-0 flex items-center px-6">
    <ul class="lg:h-24 lg:flex items-center w-full lg:w-auto">
      <li>
        <router-link :to="{ name: 'Home' }" class="flex flex-row items-center h-12 px-2 rounded-lg text-gray-500">
          <span class="flex items-center justify-center text-lg text-gray-500">
            <!-- <img src="@/assets/ninja.png" /> -->
          </span>
          <span class="text-dusty-gray lg:text-2xl">SchoolBoard</span>
        </router-link>
      </li>
    </ul>
    <div class="container flex flex-wrap items-center lg:flex-no-wrap">
      <a href="#" class="lg:hidden ml-auto flex flex-col relative justify-center w-8 h-8" @click.prevent="mobileNavOpen = !mobileNavOpen">
        <span class="bg-gray-100 h-1 w-8 rounded mb-1"></span>
        <span class="bg-gray-100 h-1 w-8 rounded mb-1"></span>
        <span class="bg-gray-100 h-1 w-8 rounded mb-1"></span>
      </a>

      <div
        class="w-full flex"
        :class="{
          'mt-8': mobileNavOpen,
          'hidden lg:flex': !mobileNavOpen,
        }"
      >
        <ul class="lg:h-24 lg:flex items-center ml-auto text-right w-full lg:w-auto">
          <template v-if="user">
            <li>
              <router-link :to="{ name: 'Post' }" class="text-zumthor lg:py-5 lg:p-3">Post</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'TodoList' }" class="text-zumthor lg:py-5 lg:p-3">TodoList</router-link>
            </li>

            <li>
              <router-link :to="{ name: 'Dashboard' }" class="text-zumthor lg:py-5 lg:p-3">
                <span class="text-zumthor ">Dashboard </span>
              </router-link>
            </li>
            <li><button @click="handleClick" class=" text-zumthor  bg-transparent hover:bg-gray-700">Logout</button></li>
          </template>
          <template v-else>
            <li>
              <router-link :to="{ name: 'Login' }" class=" text-zumthor lg:py-5  lg:p-3">Login</router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// challenge
//   - only show the logout button if we are logged in
//   - only show the signup and login links if we are not logged in
//   - use the getUser composable to help

import getUser from "../composables/getUser"
import useLogout from "../composables/useLogout"

export default {
  data() {
    return {
      mobileNavOpen: false,
    }
  },
  setup() {
    const { user } = getUser()
    const { logout } = useLogout()

    const handleClick = async () => {
      await logout()
      console.log("logged out")
      router.push({ name: "Login" })
    }

    return { handleClick, user }
  },
}
</script>
